/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import classnames from 'classnames';

/** Picker for ad customizer
 * all editor are on top of this
 * it will do following things
 *  1 show syntax when syntax is not null
 *  2 show editor when editorView not null
 *  3 show the selectable items when itemsToDisplay not empty and editorview null
 */
export class AdCustomizerPicker extends React.Component {
  static defaultProps = {
    itemsToDisplay: [],
    syntax: '',
    editorView: null,
    target: null,
    container: $('body'),
  };

  constructor(props) {
    super(props);

    const {
      itemsToDisplay, syntax, editorView, target, activity,
    } = this.props;

    this.state = {
      itemsToDisplay,
      syntax,
      editorView,
      target,
    };
    this.activity = activity;
  }

  // update state when props update
  static getDerivedStateFromProps(nextProps) {
    const {
      itemsToDisplay, syntax, editorView, target,
    } = nextProps;

    return {
      target,
      itemsToDisplay,
      syntax,
      editorView,
    };
  }

  getDisplayPosition(target, container) {
    const $target = $(target);
    const targetOffset = $target.offset();
    const containerOffset = container.offset();

    // Calculate the position of the popup relative to the container.
    // The container needs to be non-statically positioned, either fixed, relative or absolute,
    // because the popup is position: absolute.
    return {
      top: (targetOffset.top - containerOffset.top) + $target.outerHeight(),
      left: targetOffset.left - containerOffset.left,
    };
  }

  render() {
    const {
      target,
      editorView,
      syntax,
      itemsToDisplay,
    } = this.state;
    const position = this.getDisplayPosition(target, this.props.container);

    const containerStyle = { display: 'block', left: `${position.left}px`, top: `${position.top}px` };
    let syntaxToUse = null;

    if (syntax) {
      syntaxToUse = (
        <div className="adcustomizerpicker-syntax-container">
          {syntax}
        </div>);
    }

    let contentView = null;
    let contentClasses = [];

    if (editorView) {
      contentView = (<div className="picker-content">{editorView}</div>);
      contentClasses = ['adCustomizersEditor'];
    } else {
      contentClasses = ['picker-list'];
      contentView = itemsToDisplay.map(({ name, description, onClick }, index) => {
        const updatedOnClick = (event) => {
          this.activity.trace(`${this.props.adType} AdCustomizersPicker`, `${name} selected`);
          onClick(event);
          event.stopPropagation();
          event.preventDefault();
        };
        return (
          <li role="menuitem">
            <a
              arial-label={description}
              href="#"
              onClick={updatedOnClick}
              key={name}
              data-index={index}
            >
              <div className="type-bold">{name}</div>
              { description ? <div className="type-normal">{description}</div> : null}
            </a>
          </li>);
      }, this);
    }

    return (
      <ul className={classnames('dropdown-menu', 'bypass-acccessibility-tweak', ...contentClasses)} role="menu" style={containerStyle}>
        {syntaxToUse}
        {contentView}
      </ul>
    );
  }
}

AdCustomizerPicker.propTypes = {
  itemsToDisplay: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    onClick: PropTypes.func,
  })),
  syntax: PropTypes.shape({}),
  editorView: PropTypes.shape({}),
  target: PropTypes.shape({}),
  activity: PropTypes.shape({ trace: PropTypes.func }).isRequired,
  container: PropTypes.shape({ offset: PropTypes.func }),
  adType: PropTypes.string.isRequired,
};
